import actionCreatorFactory from "typescript-fsa";
import { GroupDetailRequestBody, GroupDetailResponse } from "../../core/api/requests/group/detail/types";
import { GroupEditRequestBody, GroupEditResponse } from "../../core/api/requests/group/edit/types";
import { GroupListRequestBody, GroupListResponse } from "../../core/api/requests/group/list/types";
import { GroupRegisterRequestBody, GroupRegisterResponse } from "../../core/api/requests/group/register/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@Group");

export const groupActions = {
  fetchGroups: actionCreator.async<CommonAsyncType<GroupListResponse> & GroupListRequestBody, GroupListResponse>("FETCH_GROUPS"),
  getGroupDetails: actionCreator.async<CommonAsyncType<GroupDetailResponse> & GroupDetailRequestBody, GroupDetailResponse>("GET_GROUP_DETAILS"),
  registerNewGroup: actionCreator.async<CommonAsyncType<GroupRegisterResponse> & GroupRegisterRequestBody, GroupRegisterResponse>("REGISTER_NEW_GROUP"),
  updateGroup: actionCreator.async<CommonAsyncType<GroupEditResponse> & GroupEditRequestBody, GroupEditResponse>("UPDATE_GROUP"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
